export const loadQiyuSdk = () => {
  if (window.ysf) return
  (function (w, d, n, a, j) {
    w[n] =
      w[n] ||
      function () {
        (w[n].a = w[n].a || []).push(arguments)
      }
    j = d.createElement('script')
    j.async = true
    j.src =
      'https://qiyukf.com/script/67ce8aef9cc20170fab92a3f1807a316.js?subdomain=1&hidden=1&appKey=67ce8aef9cc20170fab92a3f1807a316'
    d.body.appendChild(j)
  })(window, document, 'ysf')
}
